export default function hasLowercaseLetter(value: string) {
  return /[a-z]/.test(value);
}
